<template>
  <div class="domain-trademark">
    <div class="new-domain-banner">
      <div class="banner-img">
        <div class="link-switch auto fix">
          <a style
             href="/domain">注册域名</a>
          <!-- <a href="/trademark">注册商标</a> -->
        </div>
        <!-- <span class="banner-title">商标 域名注册</span> -->
      </div>
    </div>
    <div class="trademark-search">
      <div class="trademark-search-bar">
        <input
          type="text"
          class="search-bar-input"
          placeholder="请输入要查询的域名前缀..."
          v-model="domainName"
        />
        <div class="search-bar-mask">.商标</div>
        <button class="search-bar-btn" @click="query">查询</button>
      </div>
    </div>
    <div class="trademark-advantage fix" style="margin-bottom: 55px;">
      <div class="f24 tc trademark-block-title">注册 .商标 域名的好处</div>
      <div class="fix" style="width:1200px;margin:auto;">
        <div class="trademark-advantage-item fl" v-for="(item, index) in goodList" :key="index">
          <div class="item-header tc f24">{{item.header}}</div>
          <div class="item-body c6">{{item.body}}</div>
        </div>
      </div>
    </div>
    <div class="trademark-process fix">
      <div class="f24 tc trademark-block-title">.商标 域名的注册流程</div>
      <div style="width:1200px;margin:auto;padding-bottom:100px;" class="fix">
        <div class="fl" v-for="(item, index) in processList" :key="index">
          <div class="trademark-process-item tc fl">
            <img :src="item.img" class="trademark-process-item-img mr25" alt />
            <div class="item-header tc f16 c3">{{item.header}}</div>
            <div class="item-body c9 f14">{{item.body}}</div>
          </div>
          <div class="fl trademark-process-item-line" v-if="(index+1)!=processList.length">
            <img src="../static/assets/trademark11.png" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="trademark-data">
      <div class="f24 tc trademark-block-title">.商标 域名注册资料准备</div>
      <div style="width:1200px;margin:auto;" class="fix">
        <div class="trademark-data-item tc fl" v-for="(item, index) in dataList" :key="index">
          <div
            class="f16 c3 mb10 trademark-data-item-height"
            style="padding-top: 60px;"
          >{{item.firstLine}}</div>
          <div class="item-header f16 c3 mb20 trademark-data-item-height">{{item.sedLine}}</div>
          <div class="item-body c9 f14 trademark-data-item-height">{{item.thiLine}}</div>
        </div>
      </div>
    </div>
    <div class="trademark-name">
      <div class="f24 tc trademark-block-title">.商标 域名命名建议</div>
      <div style="width:1200px;margin:auto;padding-bottom:80px;" class="fix">
        <div class="trademark-name-item fl" v-for="(item, index) in nameList" :key="index">
          <img class="fl" :src="item.img" alt />
          <div class="trademark-name-item-block fl">
            <div class="f14 c6 item-header fl">{{item.header}}</div>
            <div class="item-body f14 c6 fl tc">.商标</div>
          </div>
        </div>
      </div>
    </div>
    <div class="trademark-faq">
      <div class="f24 tc trademark-block-title">.商标 域名FAQ</div>
      <div style="width:1200px;margin:auto;" class="fix">
        <div class="trademark-faq-item" v-for="(item, index) in faqList" :key="index">
          <div class="f14 c3 item-header">{{item.header}}</div>
          <div class="item-body f14 c6" v-html="item.body"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      domainName: "",
      domainSuffix: "",
      nameList: [
        {
          img: require("../static/assets/trademark10.png"),
          header: "商标名",
          body: "“.商标”是商标持有人在互联网上的身份标识，是互联网的品牌象征"
        },
        {
          img: require("../static/assets/trademark7.png"),
          header: "商标名 + 商品/服务项目",
          body:
            "“.商标”有效保证持有人身份的真实性，从而有效保证“.商标”持有人在互联网上所提供产品和服务的可信度"
        },
        {
          img: require("../static/assets/trademark8.png"),
          header: "指定地 + 商标名",
          body:
            "“.商标”一旦取得，持有人将成为此行业唯一拥有此“.商标”名称的持有人。其他人无法注册、使用相同“.商标”，享有独立专用权"
        },
        {
          img: require("../static/assets/trademark9.png"),
          header: "指定地 + 商标名 + 商品/服务项目",
          body:
            "“.商标”是互联网上具有品牌商标标识性资源，是持有人在互联网上的无形资产"
        }
      ],
      goodList: [
        {
          header: "标识性",
          body: "“.商标”是商标持有人在互联网上的身份标识，是互联网的品牌象征"
        },
        {
          header: "可信性",
          body:
            "“.商标”有效保证持有人身份的真实性，从而有效保证“.商标”持有人在互联网上所提供产品和服务的可信度"
        },
        {
          header: "唯一性",
          body:
            "“.商标”一旦取得，持有人将成为此行业唯一拥有此“.商标”名称的持有人。其他人无法注册、使用相同“.商标”，享有独立专用权"
        },
        {
          header: "资源性",
          body:
            "“.商标”是互联网上具有商标品牌标识性资源，是持有人在互联网上的无形资产"
        }
      ],
      processList: [
        {
          img: require("../static/assets/trademark1.png"),
          header: "选择",
          body: "选择 .商标 域名"
        },
        {
          img: require("../static/assets/trademark2.png"),
          header: "查询",
          body: "查询是否可注"
        },
        {
          img: require("../static/assets/trademark3.png"),
          header: "确认",
          body: "确认订单"
        },
        {
          img: require("../static/assets/trademark4.png"),
          header: "提交",
          body: "提交域名审核材料"
        },
        {
          img: require("../static/assets/trademark5.png"),
          header: "等待",
          body: "注册局审核结果"
        },
        {
          img: require("../static/assets/trademark6.png"),
          header: "成功",
          body: "审核通过，注册成功"
        }
      ],
      dataList: [
        {
          firstLine: "商标证书",
          sedLine: "扫描件",
          thiLine: "（注册.商标域名必备）"
        },
        {
          firstLine: "企业",
          sedLine: "营业执照复印件",
          thiLine: ""
        },
        {
          firstLine: "机构或组织",
          sedLine: "成立和登记证明文件",
          thiLine: ""
        },
        {
          firstLine: "个人工商户",
          sedLine: "营业执照副本",
          thiLine: ""
        },
        {
          firstLine: "个人",
          sedLine: "身份证正反面复印件",
          thiLine: ""
        }
      ],
      faqList: [
        {
          header: "1.什么是“.商标”域名？",
          body: ".商标域名是以商标两个汉字作为域名后缀的新通用顶级域名。"
        },
        {
          header: "2.没有商标权利证明是否可以注册“.商标”域名？",
          body:
            "不可以。<br>注册.商标域名必须提供商标权利证明，如商标注册证书。目前只接受已核准注册的商标注册证作为.商标域名的注册申请材料，并且要求.商标域名持有者必须与商标注册人一致。"
        },
        {
          header: "3.是否可以凭商标申请证明注册“.商标”域名？？",
          body:
            "不可以。<br>注册.商标域名必须提供有效的商标权利证明材料，如商标注册证书。目前只接受已核准注册的商标注册证作为.商标域名的注册申请材料。"
        },
        {
          header: "4.“.商标”域名是否要求实名认证？",
          body: "是的。<br>注册.商标域名后，必须完成实名认证才能正常解析。"
        },
        {
          header: "5.“.商标”域名是否支持备案？",
          body: "支持备案。"
        },
        {
          header: "6.“.商标”域名生命周期与商标注册日期的关系是什么？",
          body:
            ".商标域名生命周期从域名注册日期开始至域名到期日期结束。商标注册有相应的有效期。.商标域名持有者必须确保域名注册期限内相应的商标维持有效。说明：若域名注册资料发生信息变更（包括但不限于：商标注册获得续展，商标注册被宣告无效、被撤销或未获得续展等），域名持有者应当及时通过注册商向注册局提供准确的信息和证明，否则注册局有权注销域名或冻结域名。"
        },
        {
          header: "7.图形商标是否可以用于申请注册“.商标”域名？	",
          body:
            "不可以。<br>只有包含显著文字的商标才可以用于申请注册.商标域名。纯图形商标中没有可辨识的文字，无法从中提取出文字标示来注册.商标域名。"
        },
        {
          header:
            "8.商标名称拼音或英文单词的首字母缩写是否可以用于注册“.商标”域名？",
          body:
            "不可以。<br>注册.商标域名时需要使用商标注册证上文字或商标名称的显著部分。特殊情况以注册局审核结果为准。"
        },
        {
          header: "9.是否支持在线过户或转移“.商标”域名？",
          body: "暂不支持商标域名的过户和转移。"
        },
        {
          header: "10.商标域名在提交注册后多少天可以注册成功？",
          body:
            ".商标 域名提交注册后，必须提交相关商标信息及实名制资料，注册局会在1-10天进行审核，审核通过后域名方可注册成功，域名在为审核注册成功时是不允许做任何操作的，如修改dns及信息等的。"
        }
      ]
    }
  },
  methods: {
    query () {
      const reg = new RegExp(
        "^[A-Za-z０１２３４５６７８９－0-9-Ａ-Ｚａ-ｚ\u4e00-\u9fa5]+$"
      )
      this.domainName = this.domainName.trim()
      // 如果不输入，不执行操作
      if (!this.domainName) return

      // 完整域名拆分处理
      const index = this.domainName.indexOf(".")
      if (index !== -1) {
        this.domainSuffix = this.domainName.substr(index)
        this.domainName = this.domainName.substr(0, index)
      }

      // 如果用户输入的域名后缀不在后缀列表，重置为.com
      // if (
      //   this.domainSuffix &&
      //   suffix1.indexOf(this.domainSuffix) === -1 &&
      //   suffix2.indexOf(this.domainSuffix) === -1 &&
      //   suffix3.indexOf(this.domainSuffix) === -1
      // ) {
      //   this.domainSuffix = "";
      // }
      this.domainSuffix = ".商标"
      if (this.domainName.length > 63) {
        this.$msgbox({
          type: "error",
          message: "域名长度超出最大限制！"
        })
        return
      }

      if (!reg.test(this.domainName)) {
        if (this.language === "cn") {
          this.$msgbox({
            title: "您输入的域名不符合注册规则，请重新输入",
            type: "error",
            message:
              "提示：中文域名至少需要含有一个中文文字，可以包含中文、字母a-z(大小写等价)、数字0-9或者半角的连接符“-”，“-”不能放在开头或者结尾，输入内容不能超过63个字符，最多可以注册19个汉字。"
          })
        } else {
          this.$msgbox({
            title: "您输入的域名不符合注册规则，请重新输入",
            type: "error",
            message:
              "提示：域名可由英文字母（a-z,不区分大小写）、数字（0-9）、连字符“-”（即中横线）,不能使用空格及特殊字符（如！、$、&、？等），“-”不能单独填写或连续使用，不能放在开头或结尾，输入内容不能超过63个字符。"
          })
        }

        return
      }

      // this.$emit("query", {
      //   domainName: this.domainName,
      //   domainSuffix: this.domainSuffix
      // });

      this.$router.push({
        path: "/domain/result",
        query: {
          domainName: this.domainName.toLowerCase(),
          domainSuffixs: this.domainSuffix
        }
      })
    }
  }
};
</script>
<style lang="scss">
@import "../static/css/domain-trademark.scss";
</style>




// WEBPACK FOOTER //
// src/trademark.vue